import { render } from "./SidebarPainel.vue?vue&type=template&id=4fb61364"
import script from "./SidebarPainel.vue?vue&type=script&lang=js"
export * from "./SidebarPainel.vue?vue&type=script&lang=js"

import "./SidebarPainel.vue?vue&type=style&index=0&id=4fb61364&lang=scss"

import exportComponent from "/home/runner/work/alperlab/alperlab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__